import { kpiApi } from "@/api/kpiApi";
import TextLink from "@/components/Link/TextLink";
import { MoreVert } from "@mui/icons-material";
import ClearIcon from "@mui/icons-material/Clear";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Collapse,
    Divider,
    IconButton,
    ListItemIcon,
    Menu,
    MenuItem,
    Stack,
} from "@mui/material";
import { useState } from "react";

function TrackingLink(props) {
    const { tracking, to, label, onClickDelete } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => setAnchorEl(event.target);
    const handleClose = () => setAnchorEl(null);
    const handleRemove = () => {
        if (confirm("ต้องการลบข้อมูลหรือไม่?") && onClickDelete instanceof Function) {
            onClickDelete();
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            <Box>
                <TextLink to={to}>
                    {label} [{tracking.trackable?.code}]{" "}
                    <Box component="span" sx={{ color: "gray" }}>
                        #{tracking.trackable?.id}
                    </Box>
                </TextLink>
            </Box>

            <Box sx={{ marginLeft: "auto" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box sx={{ color: "gray" }}>
                        {/** updated 0000/00/00 by user.fullname */}
                        {new Date(tracking.updated_at ?? tracking.created_at).toLocaleDateString()}
                    </Box>
                    {/** trigger */}
                    <IconButton onClick={handleOpen}>
                        <MoreVert />
                    </IconButton>
                </Box>
                {/** menu */}
                <Menu anchorEl={anchorEl} open={open} onClick={handleClose} onClose={handleClose}>
                    <MenuItem onClick={handleRemove} sx={{ color: "red" }}>
                        <ListItemIcon>
                            <ClearIcon />
                        </ListItemIcon>
                        delete
                    </MenuItem>
                </Menu>
            </Box>
        </Box>
    );
}

export default function TrackingSection({ kpiId, trackings }) {
    const [openForm, setOpenForm] = useState(false);
    const count = trackings.length ?? 0;

    const groupTrackings = _.groupBy(
        _.sortBy(trackings, ["trackable_type.name_display", "trackable.title"]),
        "trackable_type.name"
    );

    // delete mutation
    const [deleteTrackingById] = kpiApi.endpoints.deleteKpiTrackingById.useMutation();
    const handleDeleteTrackingById = (id) => deleteTrackingById({ kpiId, trackingId: id });

    return (
        <Card variant="outlined">
            <CardHeader
                title={`เชื่อมโยงแผน (${count})`}
                // action={
                //     <Box sx={{ display: "flex", alignItem: "center", justifyContents: "center" }}>
                //         <Button variant="outlined" onClick={() => setOpenForm((prev) => !prev)}>
                //             add
                //         </Button>
                //     </Box>
                // }
            ></CardHeader>
            <Divider variant="middle" />
            <CardContent>
                <Collapse in={openForm}>
                    <Box sx={{ backgroundColor: "white", paddingY: 2 }}></Box>
                </Collapse>

                <Stack>
                    {Object.entries(groupTrackings)?.map(([key, trackings]) => (
                        <Box key={key}>
                            <Box sx={{ fontWeight: "bold" }}>{trackings[0]?.trackable_type?.name_display}</Box>
                            <Box sx={{ marginLeft: 5 }}>
                                {trackings?.map((tracking) => (
                                    <TrackingLink
                                        key={tracking.id}
                                        tracking={tracking}
                                        to="#"
                                        // to={`/kpis/${relation.target?.id}`}
                                        label={tracking.trackable?.title}
                                        onClickDelete={() => handleDeleteTrackingById(tracking.id)}
                                    />
                                ))}
                            </Box>
                        </Box>
                    ))}
                </Stack>
            </CardContent>
        </Card>
    );
}
